import { AgencyQueryProvider } from "__legacy/queries/agencies/AgencyQueryProvider";
import { EmploymentQueryProvider } from "__legacy/queries/employments/EmploymentQueryProvider";
import { UpdateEmploymentMutationProvider } from "__legacy/queries/employments/UpdateEmploymentMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, UserForm } from "./UserForm";

export const Edit: React.FC<{}> = () => {
  const { agencyId, id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <AgencyQueryProvider variables={{ id: agencyId }}>
      {({ agency }) => (
        <EmploymentQueryProvider variables={{ id: id }}>
          {({ employment }) => (
            <UpdateEmploymentMutationProvider
              onError={onError(form, setErrors)}
              onCompleted={() => navigate("../../../")}
            >
              {(loading, mutate) => (
                <Fragment>
                  <PageHeader
                    ghost={true}
                    title={`Edit agency user for ${agency.name} on ${employment.user.email}`}
                    extra={
                      <Fragment>
                        <Button onClick={() => navigate("../../../../")}>Back to list</Button>
                        <Button onClick={() => navigate("../../../")}>Back to agency</Button>
                        <Button type="primary" loading={loading} onClick={() => form.submit()}>
                          Save
                        </Button>
                      </Fragment>
                    }
                  />
                  <Layout.Content className="content">
                    <UserForm
                      action="update"
                      form={form}
                      handler={onFinish(mutate, {}, { id })}
                      values={employment}
                      errors={errors}
                    />
                  </Layout.Content>
                </Fragment>
              )}
            </UpdateEmploymentMutationProvider>
          )}
        </EmploymentQueryProvider>
      )}
    </AgencyQueryProvider>
  );
};
